import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 0,
  class: "mt-3 p-3 bg-slate-50 rounded flex items-center gap-3"
};
const _hoisted_3 = {
  class: "flex-1 min-w-0"
};
const _hoisted_4 = {
  class: "text-sm text-slate-700 truncate"
};
const _hoisted_5 = {
  class: "text-xs text-slate-400"
};
const _hoisted_6 = {
  key: 1,
  class: "mt-3"
};
const _hoisted_7 = {
  key: 2,
  class: "mt-3"
};
const _hoisted_8 = {
  key: 1,
  class: "text-center py-8"
};
const _hoisted_9 = {
  class: "text-sm text-slate-500 mt-3"
};
const _hoisted_10 = ["disabled"];
const _hoisted_11 = ["disabled"];
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import { UploadFilled, Document } from '@element-plus/icons-vue';
import { createUploadSession, confirmUploadSession, cancelUploadSession } from '@/api/assets';
import axios from 'axios';
export default {
  __name: 'AssetUploadDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    folderId: {
      type: [Number, String],
      default: null
    },
    assetId: {
      type: [Number, String],
      default: null
    },
    tagList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const fileInput = ref(null);
    const selectedFile = ref(null);
    const assetName = ref('');
    const selectedTagIds = ref([]);
    const uploading = ref(false);
    const uploadProgress = ref(0);
    const uploadStatus = ref('');
    const uploadMessage = ref('');
    const currentSessionId = ref(null);
    function triggerFileInput() {
      fileInput.value?.click();
    }
    function handleFileSelect(e) {
      const file = e.target.files?.[0];
      if (file) {
        selectedFile.value = file;
        // 自动填名称
        if (!assetName.value) {
          const dotIdx = file.name.lastIndexOf('.');
          assetName.value = dotIdx > 0 ? file.name.substring(0, dotIdx) : file.name;
        }
      }
    }
    function handleDrop(e) {
      const file = e.dataTransfer?.files?.[0];
      if (file) {
        selectedFile.value = file;
        if (!assetName.value) {
          const dotIdx = file.name.lastIndexOf('.');
          assetName.value = dotIdx > 0 ? file.name.substring(0, dotIdx) : file.name;
        }
      }
    }
    function getAssetType(file) {
      if (file.type.startsWith('image/')) return 'IMAGE';
      if (file.type.startsWith('video/')) return 'VIDEO';
      return 'FILE';
    }
    function formatSize(bytes) {
      if (!bytes) return '';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
      if (bytes < 1073741824) return (bytes / 1048576).toFixed(1) + ' MB';
      return (bytes / 1073741824).toFixed(1) + ' GB';
    }
    async function handleUpload() {
      if (!selectedFile.value) return;
      const file = selectedFile.value;
      const assetType = getAssetType(file);
      uploading.value = true;
      uploadProgress.value = 0;
      uploadStatus.value = '';
      uploadMessage.value = '正在申请上传凭证...';
      try {
        // Step 1: 申请上传凭证
        const sessionData = {
          folderId: props.folderId,
          assetId: props.assetId || undefined,
          assetType,
          originalName: file.name,
          mimeType: file.type || 'application/octet-stream',
          fileSize: file.size
        };
        const credential = await createUploadSession(sessionData);
        currentSessionId.value = credential.sessionId;

        // Step 2: 直传 OSS
        uploadMessage.value = '正在上传文件...';
        await axios.put(credential.uploadUrl, file, {
          headers: {
            'Content-Type': file.type || 'application/octet-stream',
            ...(credential.headers || {})
          },
          onUploadProgress: e => {
            if (e.total) {
              uploadProgress.value = Math.round(e.loaded / e.total * 90);
            }
          }
        });

        // Step 3: 确认上传
        uploadMessage.value = '正在创建素材...';
        uploadProgress.value = 92;
        await confirmUploadSession(credential.sessionId, {
          uploadToken: credential.uploadToken,
          name: assetName.value || undefined,
          tagIds: selectedTagIds.value,
          changeRemark: props.assetId ? '上传新版本' : undefined
        });
        currentSessionId.value = null;
        uploadProgress.value = 100;
        uploadStatus.value = 'success';
        uploadMessage.value = '上传完成';
        ElMessage.success(props.assetId ? '新版本上传成功' : '素材上传成功');
        setTimeout(() => {
          selectedFile.value = null;
          assetName.value = '';
          selectedTagIds.value = [];
          uploading.value = false;
          uploadProgress.value = 0;
          emit('success');
        }, 800);
      } catch (err) {
        await cancelPendingSession();
        uploadStatus.value = 'exception';
        uploadMessage.value = '上传失败';
        uploading.value = false;
      }
    }
    async function cancelPendingSession() {
      if (!currentSessionId.value) return;
      const sessionId = currentSessionId.value;
      currentSessionId.value = null;
      try {
        await cancelUploadSession(sessionId);
      } catch {
        // 取消失败不阻塞用户关闭或重试上传
      }
    }
    async function handleCancel() {
      if (uploading.value) return;
      await cancelPendingSession();
      selectedFile.value = null;
      assetName.value = '';
      selectedTagIds.value = [];
      emit('update:visible', false);
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: "上传素材",
        width: "520px",
        "close-on-click-modal": false,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.$emit('update:visible', $event))
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          disabled: uploading.value,
          onClick: handleCancel
        }, "取消", 8, _hoisted_10), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: !selectedFile.value || uploading.value,
          onClick: handleUpload
        }, _toDisplayString(uploading.value ? '上传中...' : '上传'), 9, _hoisted_11)]),
        default: _withCtx(() => [!uploading.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
          class: "upload-drop-zone border-2 border-dashed border-slate-300 rounded-lg p-8 text-center cursor-pointer hover:border-primary-400 hover:bg-primary-50/30 transition-colors",
          onClick: triggerFileInput,
          onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
          onDrop: _withModifiers(handleDrop, ["prevent"])
        }, [_createVNode(_component_el_icon, {
          size: 40,
          class: "text-slate-300 mb-2"
        }, {
          default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
          _: 1
        }), _cache[5] || (_cache[5] = _createElementVNode("p", {
          class: "text-sm text-slate-500 mb-1"
        }, "点击或拖拽文件到此处", -1)), _cache[6] || (_cache[6] = _createElementVNode("p", {
          class: "text-xs text-slate-400"
        }, " 支持图片、视频、文档、压缩包等 ", -1)), _cache[7] || (_cache[7] = _createElementVNode("p", {
          class: "text-xs text-slate-400 mt-1"
        }, " 图片最大 20MB，视频最大 500MB，文件最大 100MB ", -1)), _createElementVNode("input", {
          ref_key: "fileInput",
          ref: fileInput,
          type: "file",
          class: "hidden",
          onChange: handleFileSelect
        }, null, 544)], 32), selectedFile.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_icon, {
          size: 20,
          class: "text-slate-400"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Document))]),
          _: 1
        }), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(selectedFile.value.name), 1), _createElementVNode("p", _hoisted_5, _toDisplayString(formatSize(selectedFile.value.size)), 1)]), _createElementVNode("button", {
          type: "button",
          class: "btn-text-danger",
          onClick: _cache[1] || (_cache[1] = $event => selectedFile.value = null)
        }, "移除")])) : _createCommentVNode("", true), !props.assetId ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[8] || (_cache[8] = _createElementVNode("label", {
          class: "text-xs text-slate-500 mb-1 block"
        }, "素材名称", -1)), _createVNode(_component_el_input, {
          modelValue: assetName.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => assetName.value = $event),
          placeholder: "输入素材名称",
          maxlength: "200"
        }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), !props.assetId && props.tagList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[9] || (_cache[9] = _createElementVNode("label", {
          class: "text-xs text-slate-500 mb-1 block"
        }, "标签", -1)), _createVNode(_component_el_select, {
          modelValue: selectedTagIds.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => selectedTagIds.value = $event),
          multiple: "",
          placeholder: "选择标签",
          class: "w-full",
          clearable: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tagList, tag => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: tag.id,
              label: tag.name,
              value: tag.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_progress, {
          percentage: uploadProgress.value,
          "stroke-width": 8,
          status: uploadStatus.value
        }, null, 8, ["percentage", "status"]), _createElementVNode("p", _hoisted_9, _toDisplayString(uploadMessage.value), 1)]))]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};